import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CartItemsService } from '../../shared/services/cart-items.service';
import { AbstractItemRow } from '../../shared/components/abstract-item-row/abstract-item-row';
import { Response } from '@angular/http';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ThumbSourceFactoryService } from '../../shared/services/thumb-source-factory.service';
import { SluggerService } from '../../shared/services/slugger.service';

@Component({
    selector: 'cart-row',
    templateUrl: './cart.row.component.html',
    styleUrls: ['./../cart.component.scss']
})
export class CartRowComponent extends AbstractItemRow implements OnInit {
    public quantityBeforeChangeAttempt;
    public quantityModel: number;
    public quantity: number;
    public loading = false;
    @Output() updated: EventEmitter<any> = new EventEmitter();
    @Output() removed: EventEmitter<any> = new EventEmitter();

    constructor(
        protected cartItemsService: CartItemsService,
        protected toastr: ToastrService,
        protected translate: TranslateService,
        protected thumbFactory: ThumbSourceFactoryService,
        protected slugger: SluggerService
    ) {
        super();
        this.thumbFactory = thumbFactory;
    }

    ngOnInit() {
        this.quantityBeforeChangeAttempt = this.item.quantity;
        this.quantityModel = this.item.quantity;
        this.setQuantity(this.item.quantity);
    }

    /**
     * This trigger cart item remove to API.
     **/
    public remove(): void {
        this.loading = true;
        this.cartItemsService
            .remove(this.item.row_id, this.item.id, this.item.type)
            .subscribe(() => {
                this.removed.emit(this.item);
                this.loading = false;
            }, () => {
                this.loading = false;
            });
    }
    /**
     * This trigger cart item update quantity to API.
     **/
    public changeQuantityInput(): void {
        this.quantityBeforeChangeAttempt = this.getQuantity();
        this.runUpdateQuantity(this.quantityModel);
    }
    /**
     * This increment quantity and then trigger cart item update quantity to
     * API.
     **/
    public increment(): void {
        this.quantityBeforeChangeAttempt = this.quantityModel;
        this.runUpdateQuantity(this.getQuantity() + 1);
    }
    /**
     * This decrement quantity and then trigger cart item update quantity to
     * API.
     **/
    public decrement(): void {
        const quantity = this.getQuantity() - 1;
        if (quantity > 0) {
            this.quantityBeforeChangeAttempt = this.quantityModel;
            this.runUpdateQuantity(quantity);
        }
    }
    /**
     * Cart item is decrementable when is editable and type is different than
     * 'plan'.
     **/
    public isDecrementable(): boolean {
        return !!this.item.attributes.editable && this.item.type !== 'plan';
    }
    /**
     * Cart item is incrementable when is editable and type is different than
     * 'plan'.
     **/
    public isIncrementable(): boolean {
        return !!this.item.attributes.editable && this.item.type !== 'plan';
    }
    /**
     * Cart item removable cart item attribute.
     **/
    public isRemovable(): boolean {
        return !!this.item.attributes.removable;
    }
    /**
     * Check gettable attribute from item.
     **/
    public isGettable(): boolean {
        return this.item.attributes.gettable;
    }
    /**
     * Make an slug from item name to be a class for cart row.
     **/
    public cartRowClass(): string {
        return this.slugger.make(this.item.name);
    }

    /** Setting quantity property casting as number */
    private setQuantity(quantity) {
        this.quantity = +quantity;

        return +this.quantity;
    }
    /** Getting quantity property casting as number */
    private getQuantity() {
        return +this.quantity;
    }
    /**
     * This trigger cart item update quantity to API.
     **/
    private runUpdateQuantity(quantity): void {
        this.loading = true;
        this.cartItemsService.update(
            this.item.row_id,
            this.item.id,
            this.item.type,
            quantity
        ).subscribe(() => {
            this.setQuantity(quantity);
            this.quantityBeforeChangeAttempt = this.getQuantity();
            this.quantityModel = this.getQuantity();
            this.updated.emit();
            this.loading = false;
        }, (error: Response) => {
            this.quantity = this.quantityBeforeChangeAttempt;
            this.quantityModel = this.quantityBeforeChangeAttempt;
            this.loading = false;
            this.translate
                .get('CART.ROW.ERRORS.RUN_UPDATE_QUANTITY_ERROR.TITLE')
                .subscribe(title => {
                    this.toastr.error(
                        error.json().message,
                        title,
                        {}
                    );
                });
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/cart/row/cart.row.component.ts